module.exports = __webpack_public_path__ + "img/Nuove_Tecnologie_Icon.d53490ef.png";